import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2ProviderPulseHeartbeat: build.mutation<
      PostV2ProviderPulseHeartbeatApiResponse,
      PostV2ProviderPulseHeartbeatApiArg
    >({
      query: () => ({ url: `/v2/provider/pulse/heartbeat`, method: "POST" }),
    }),
    postV2ProviderPulseByPulseIdOutcome: build.mutation<
      PostV2ProviderPulseByPulseIdOutcomeApiResponse,
      PostV2ProviderPulseByPulseIdOutcomeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/pulse/${queryArg.pulseId}/outcome`,
        method: "POST",
        body: queryArg.pulseOutcomeRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2ProviderPulseHeartbeatApiResponse =
  /** status 200 OK */ PulseHeartbeatResponse;
export type PostV2ProviderPulseHeartbeatApiArg = void;
export type PostV2ProviderPulseByPulseIdOutcomeApiResponse =
  /** status 200 OK */ PulseOutcomeResponse;
export type PostV2ProviderPulseByPulseIdOutcomeApiArg = {
  pulseId: string;
  pulseOutcomeRequest: PulseOutcomeRequest;
};
export type PulseNoReasonCode =
  | "no_pending"
  | "feature_in_use"
  | "cooling_down";
export type PulseNone = {
  kind?: "none";
  /** Why there is no pulse: one value of the closed list. */
  reason_code: PulseNoReasonCode;
};
export type PulseArticle = {
  /** Topic-qualified article slug, `{topic}/{id}`, as the reader addresses it. */
  slug: string;
  /** Article summary as published. */
  summary: string;
  /** Article title as published. */
  title: string;
  /** Topic slug, the first segment of `slug`. */
  topic: string;
};
export type PulseRuleCode =
  | "jotrx_practice_setup"
  | "jotrx_learn"
  | "jotrx_prescriber_setup"
  | "jotrx_send_prescription";
export type PulseSuggestion = {
  article: PulseArticle;
  /** Display hint: whether the app offers a dismiss control. */
  dismissible: boolean;
  /** When the suggestion stops being worth showing. The app hides it after this time. */
  expires_at: string;
  kind?: "suggestion";
  /** One sentence for the Jot character. The backend owns the words. */
  prompt: string;
  /** Stable id of this served pulse. Outcomes post against it. */
  pulse_id: string;
  /** Path under `/kb` that opens the article in the web app's reader. */
  reader_url: string;
  /** The rule that produced the suggestion. */
  reason_code: PulseRuleCode;
};
export type PulseHeartbeatResponse =
  | ({
      kind: "none";
    } & PulseNone)
  | ({
      kind: "suggestion";
    } & PulseSuggestion);
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type PulseOutcomeKind = "shown" | "clicked" | "dismissed";
export type PulseOutcomeResponse = {
  /** The outcome recorded. */
  outcome: PulseOutcomeKind;
  /** The pulse the outcome was recorded against. */
  pulse_id: string;
  /** When the backend first recorded this outcome for this pulse. A repeat post returns the first time. */
  recorded_at: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type PulseOutcomeKind2 = "shown" | "clicked" | "dismissed";
export type PulseOutcomeRequest = {
  /** The outcome the app observed: shown, clicked, or dismissed. */
  outcome: PulseOutcomeKind2;
};
